if (!customElements.get('geek-availability')) {
  customElements.define('geek-availability', class extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('.js-product');
      this.onVariantChange = (event) => {
        if (!this.variantMarkup) return;
        this.querySelector('.go-availability__content').innerHTML = this.variantMarkup[event.detail.variant?.id]
          || this.querySelector('[data-availability-empty]').innerHTML;
      };
      const data = this.querySelector('[data-availability-variants]');
      if (data) this.variantMarkup = JSON.parse(data.textContent);
      this.productSection?.addEventListener('on:variant:change', this.onVariantChange);
    }
    disconnectedCallback() {
      this.productSection?.removeEventListener('on:variant:change', this.onVariantChange);
    }
  });
}
